// src/pages/PainelChamados/TabelaAcoes.jsx
import { NotePencil, Trash } from "@phosphor-icons/react";

export default function TabelaAcoes({ item, onEditar, onExcluir }) {
  return (
    <div className="flex items-center justify-center gap-2">
      {/* 🔹 Editar */}
      <button
        onClick={() => onEditar?.(item)}
        className="hover:scale-110 transition-transform p-1"
        title="Editar"
      >
        <NotePencil size={18} color="#606060" weight="duotone" />
      </button>

      {/* 🔹 Excluir */}
      <button
        onClick={() => onExcluir?.(item)}
        className="hover:scale-110 transition-transform p-1"
        title="Excluir"
      >
        <Trash size={18} color="#606060" weight="duotone" />
      </button>
    </div>
  );
}
